/**
 * Forked component from mobx-react <Link />
 * https://github.com/kitze/mobx-router/blob/master/src/components/Link.js
 * - Added onClickReaction ability
 * - Added shouldScrollBeRestored ability
 */

import React from 'react';
import {observer} from 'mobx-react';

import {UnstyledLink} from './styles';

const LinkBase = ({
  route,
  params = {},
  queryParams = {},
  store,
  refresh = false,
  onClickReaction,
  onClick = onClickReaction,
  shouldScrollBeRestored = false,
  dataCy,
  children,
  title,
  ...forwardedProps
}) => {
  const router = store.router;
  if (!router) {
    console.error('The router prop must be defined for a Link component to work!');
    return null;
  }

  return (
    <UnstyledLink
      data-cy={dataCy}
      {...forwardedProps}
      onClick={e => {
        const middleClick = e.button === 2;
        const cmdOrCtrl = e.metaKey || e.ctrlKey;
        const openinNewTab = middleClick || cmdOrCtrl;
        const shouldNavigateManually = refresh || openinNewTab || cmdOrCtrl;

        if (shouldNavigateManually) {
          if (typeof onClick === 'function') {
            onClick();
          }

          return;
        }

        e.preventDefault();

        const linkAction = () => {
          if (store?.ui) {
            store.ui.shouldScrollBeRestoredForNextRoute = shouldScrollBeRestored;
          }

          router.goTo(route, params, queryParams);

          if (typeof onClick === 'function') {
            onClick();
          }
        };

        if (store?.unsavedChangesDialog) {
          return store.unsavedChangesDialog.check().then(linkAction);
        }

        linkAction();
      }}
      href={route.replaceUrlParams(params, queryParams)}
    >
      {title || children}
    </UnstyledLink>
  );
};

export default observer(LinkBase);
